import type { Platform } from '@multimod/shared';
import { useMsgRate } from '@/features/panel/hooks/useMsgRate';
import { PlatformIcon } from '@/components/ui/platform-icon';
import { connVisual } from '@/features/chat-feed/conn-visual';
import type { ConnState } from '@/features/chat-feed/store';

export function ConnChip({
  platform,
  liveChatId,
  viewers,
  state = 'idle',
}: {
  platform: Platform;
  liveChatId: string | null;
  viewers: number | null;
  state?: ConnState;
}) {
  const rate = useMsgRate(liveChatId, liveChatId ? platform : null);
  const visual = connVisual(state);
  // `failed` reforça pintando o ícone de plataforma de destructive (única exceção
  // ao tint de plataforma — ui-ux §3). Sem live, ícone fica subtle.
  const iconColor = !liveChatId
    ? 'text-fg-subtle'
    : state === 'failed'
      ? 'text-destructive'
      : platform === 'twitch'
        ? 'text-platform-twitch'
        : 'text-platform-youtube';
  return (
    <span
      className="inline-flex items-center gap-1.5 px-2.5 h-6 rounded-sm text-xs text-fg-muted tabular-nums"
      data-platform={platform}
      data-conn-state={state}
    >
      {/* Dot de estado de 8px. Pulsa em transitório (connecting/reconnecting);
          estático em terminal. animate-pulse vira no-op sob prefers-reduced-motion
          (globals.css §5). aria-hidden — o estado também vai no data-attr e o card
          do sheet carrega o label acessível. */}
      <span
        aria-hidden="true"
        className={`h-2 w-2 rounded-full shrink-0 ${visual.dotClass}${visual.animate ? ' animate-pulse' : ''}`}
      />
      <PlatformIcon platform={platform} size={13} className={iconColor} />
      {liveChatId ? (
        <>
          <strong className="text-fg font-medium">{viewers ?? 0}</strong>
          <span aria-hidden="true">·</span>
          <strong className="text-fg font-medium">{rate}</strong>
          <span>/min</span>
        </>
      ) : (
        <span>—</span>
      )}
    </span>
  );
}
